import { IApiError } from '@frontend/request';

import { authenticationAPIController } from '@aqx-core/common/api/auth';
import { mapResponseCodeToMessage } from '@aqx-core/common/request';

import { forgotPasswordService } from './service';
import { EForgotPasswordContent, IForgotPasswordParams, ISendPasswordEmail } from './types';

class ForgotPasswordViewController {
  public reset = () => {
    forgotPasswordService.reset();
  };

  public forgotPassword = async ({ params, onError }: IForgotPasswordParams) => {
    await this.sendForgotPasswordEmail({
      params,
      onError,
      onSuccess: () => {
        const { email, metatraderId } = params;
        forgotPasswordService.setEmail(email);
        metatraderId && forgotPasswordService.setMetatraderId(metatraderId);
        forgotPasswordService.setContent(EForgotPasswordContent.COMPLETE);
      }
    });
  };

  public sendForgotPasswordEmail = async ({ params, onError, onSuccess }: ISendPasswordEmail) => {
    forgotPasswordService.setLoading(true);
    await authenticationAPIController
      .forgotPasswordLive(params, {
        onSuccess,
        onError: (error) => {
          const { code, message } = error as IApiError;
          onError(mapResponseCodeToMessage(code, message));
        }
      })
      .finally(() => {
        forgotPasswordService.setLoading(false);
      });
  };
}

export const forgotPasswordViewController = new ForgotPasswordViewController();
